import { createSelector } from 'reselect';
import _keys from 'lodash/keys';

export const getGroupList = createSelector(
  [state => state.groups.data],
  data => {
    return _keys(data).reduce((result, id) => result.concat(data[id]), []);
  }
);
